import axios from 'axios'
import { getEnvBaseURL } from '../utils/env'
// import { logAxiosError } from '../utils/sensors'
import { useSetting } from '@/composables/use-setting'
import { trackAxiosException } from '@voghion/track'


const API = axios.create({
  baseURL: getEnvBaseURL(),
  // 下面两个属性，用来设置，请求失败或者超时，自动重新请求的次数和间隙时间
  timeout: 20 * 1000 // 超时时间
  // timeout: 100 // 调试 debug
})

const { getClientInfo } = useSetting()

API.interceptors.request.use((config) => {
  const clientInfoVOObj = {
    ...getClientInfo()
  }
  // 处理非 non ISO-8859-1
  const keys = ['mediaSource', 'afChannel', 'afAdset', 'campaign']
  for (const key of keys) {
    if (clientInfoVOObj[key]) {
      clientInfoVOObj[key] = encodeURIComponent(clientInfoVOObj[key])
    }
  }
  const clientInfoVOStr = JSON.stringify(clientInfoVOObj)
  Object.assign(config.headers, { 'Cache-Control': 'no-cache', clientInfo: clientInfoVOStr })
  return config
})

export function isApiSuccess(res) {
  return res && (res.rtn_code === '0000' || res.success)
}

//请求后返回数据拦截
API.interceptors.response.use(
  (res) => {
    if (res.status == 200) {
      const data = res.data
      if (!isApiSuccess(data)) {
        trackAxiosException(res)
      }
      return data
    } else {
      return res.data || {}
    }
  },
  (err) => {
    trackAxiosException(err)
  }
)
export default API
